var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main-view"},[_c('div',{staticClass:"container-scroller"},[_c('app-header'),_c('div',{staticClass:"container-fluid page-body-wrapper"},[_c('app-sidebar'),_c('div',{staticClass:"main-panel"},[_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1),_c('app-footer')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }